const styles = {
  form: {
    pr: 1,
    pb: 1
  },
  formActions: {
    mt: 2
  },
  actionButton: {
    textTransform: 'none'
  }
};

export default styles;
